import React from 'react'
import { useNavigate } from 'react-router-dom'
import { setLimitCharacter } from '../utils'
import { Stack, Typography } from '@mui/material'
import Iconify from './Iconify'

type SubHeaderProps = {
  onPress?: () => void
  titleButton?: string
  title?: string
  goBack?: boolean
  numOfPages?: number
  path?: string
}

export function SubHeader ({ title, goBack, numOfPages = 1, path }: SubHeaderProps) {
  const navigation = useNavigate()
  const handleGoBack = () => {
    navigation(-numOfPages)
  }

  return (
    <>
      {/*<Stack sx={{ pl: '0', display: { xs: 'none', md: 'block' } }}>*/}
      {/*  <Breadcrumbs title={title} path={path} />*/}
      {/*</Stack>*/}
      <Stack sx={{ m: 1.2, pl: '12px', display: { xs: 'block', md: 'none' } }}>
        <Stack direction="row" alignItems="center">
          {goBack && <Iconify
            icon="material-symbols:arrow-back-rounded"
            onClick={handleGoBack}/>}
          <Typography variant="subtitle2" sx={{ ml: '5px' }}>{setLimitCharacter(title, 60)}</Typography>
        </Stack>
      </Stack>
    </>
  )
}
